export default __webpack_public_path__ + "static/media/adventure.7d18273a.png";